// Hook simples para verificar se o usuário logado pode usar recursos premium
// (ex.: remover fundo). A regra atual considera assinante quem:
//   - tem `assinatura_ativa === true` no objeto do usuário
//   - OU tem `plano` definido e não-expirado
//   - OU é admin
//   - OU origem=='crieoferta' (compat com sistema legado)
//
// Em produção, o ideal é que o backend exponha:
//   GET /api/assinatura.php?id_user=...
//   -> { ativa: true|false, plano: '...', expira_em: 'YYYY-MM-DD' }
//
// Aqui usamos o que já está em sessionStorage e fazemos polling leve.

import { useEffect, useState } from 'react';

const ENDPOINT_STATUS = 'https://videooferta.com/api/assinatura.php';

export function useAssinatura() {
  const [user, setUser] = useState(null);
  const [ativa, setAtiva] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancel = false;
    try {
      const raw = sessionStorage.getItem('user');
      if (!raw) { setLoading(false); return; }
      const u = JSON.parse(raw);
      setUser(u);

      // Heurística local
      const ativaLocal =
        u?.nivel === 'admin' ||
        u?.origem === 'crieoferta' ||
        u?.assinatura_ativa === true ||
        u?.assinatura_ativa === 1 ||
        u?.assinatura_ativa === '1' ||
        (u?.plano && u.plano !== 'free' && u.plano !== '');

      if (ativaLocal) {
        setAtiva(true);
        setLoading(false);
        return;
      }

      // Consulta backend (opcional). Se o endpoint não existir, mantemos o
      // resultado local.
      fetch(`${ENDPOINT_STATUS}?id_user=${encodeURIComponent(u.id)}`)
        .then(r => r.ok ? r.json() : null)
        .then(data => {
          if (cancel) return;
          if (data && (data.ativa === true || data.ativa === 1 || data.ativa === '1')) {
            setAtiva(true);
          }
        })
        .catch(() => { /* silencioso */ })
        .finally(() => { if (!cancel) setLoading(false); });
    } catch {
      setLoading(false);
    }
    return () => { cancel = true; };
  }, []);

  return { user, ativa, loading };
}
